(function () {
    const toggle = function () {
        document.body.classList.contains('mobile-cart-modal-show') ? hide() : show();
    }

    const show = function () {
        document.body.classList.add('mobile-cart-modal-show');
    }

    const hide = function () {
        document.body.classList.remove('mobile-cart-modal-show');
    }

    document.querySelectorAll('.mobile-cart-modal').forEach(section => {
        section.querySelectorAll('.modal-close').forEach((el) => {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                hide();
            });
        });
    });

    document.querySelectorAll('[rel="mobile-cart-modal"]').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            toggle();
        });
    });
}());